module.exports = __webpack_public_path__ + "static/microsoft-powerapps-a3d2d12f121aed36caa6a64f3c084e6f.png";